/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  card: Item<'Card'>;
  cardHeader: Item<'CardHeader'>;
  avatar: Item<'Avatar'>;
  iconButton: Item<'IconButton'>;
  cardContent: Item<'CardContent'>;
  cardActions: Item<'CardActions'>;
  button: Item<'Button'>;
  menu: Item<'Menu'>;
  menuItem: Item<'MenuItem'>;
  menuItem1: Item<'MenuItem'>;
  menuItemDivider: Item<'MenuItemDivider'>;
  menuItem2: Item<'MenuItem'>;
} = {
  avatar: {
    children: [],
    itemId: 'avatar',
    parent: 'cardHeader',
    props: {
      icon: {
        iconName: 'analytics',
        iconType: 'light',
      },
    },
    type: 'Avatar',
  },
  button: {
    children: [],
    itemId: 'button',
    parent: 'cardActions',
    props: {
      startIcon: {
        iconName: 'check',
        iconType: 'light',
      },
      text: {
        type: 'text',
        value: 'Submit',
      },
    },
    type: 'Button',
  },
  card: {
    children: ['cardHeader', 'cardContent', 'cardActions'],
    itemId: 'card',
    parent: 'root',
    props: {},
    type: 'Card',
  },
  cardActions: {
    children: ['button'],
    itemId: 'cardActions',
    parent: 'card',
    props: {},
    type: 'CardActions',
  },
  cardContent: {
    children: [],
    itemId: 'cardContent',
    parent: 'card',
    props: {},
    type: 'CardContent',
  },
  cardHeader: {
    children: ['avatar', 'iconButton'],
    itemId: 'cardHeader',
    parent: 'card',
    props: {
      subheader: {
        type: 'text',
        value: 'And a sub title...',
      },
      title: {
        type: 'text',
        value: 'Card Title',
      },
    },
    type: 'CardHeader',
  },
  iconButton: {
    children: ['menu'],
    itemId: 'iconButton',
    parent: 'cardHeader',
    props: {
      icon: {
        iconName: 'ellipsis-v',
        iconType: 'regular',
      },
    },
    type: 'IconButton',
  },
  menu: {
    children: ['menuItem', 'menuItem1', 'menuItemDivider', 'menuItem2'],
    itemId: 'menu',
    parent: 'iconButton',
    props: {},
    type: 'Menu',
  },
  menuItem: {
    children: [],
    itemId: 'menuItem',
    parent: 'menu',
    props: {
      icon: {
        iconName: 'plus',
        iconType: 'light',
      },
      label: {
        type: 'text',
        value: 'Create',
      },
    },
    type: 'MenuItem',
  },
  menuItem1: {
    children: [],
    itemId: 'menuItem1',
    parent: 'menu',
    props: {
      icon: {
        iconName: 'edit',
        iconType: 'light',
      },
      label: {
        type: 'text',
        value: 'Update',
      },
    },
    type: 'MenuItem',
  },
  menuItem2: {
    children: [],
    itemId: 'menuItem2',
    parent: 'menu',
    props: {
      icon: {
        iconName: 'trash',
        iconType: 'light',
      },
      label: {
        type: 'text',
        value: 'Delete',
      },
    },
    type: 'MenuItem',
  },
  menuItemDivider: {
    children: [],
    itemId: 'menuItemDivider',
    parent: 'menu',
    props: {},
    type: 'MenuItemDivider',
  },
  root: {
    children: ['card'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
};
